import { Button, FormHelperText, Grid, InputLabel, Stack, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { apiStore } from "../../../api/ApiFactory";
import { IWarrantyHistory } from "../../../models/WarrantyManagement";
import { exportToCSV } from "../../../helpers/utils/csvUtils";

interface IProps {
  closeModal: () => void,
}

const AppValidationSchema = Yup.object().shape({
  warrantyId: Yup.number()
        .typeError("Warranty Id must be numeric")
        .required("Warranty Id is required.")
  
})

const getDateString = () => {
  const date = new Date();
  return `${date.getFullYear()}${("" + (date.getMonth() + 1)).padStart(2, '0')}${("" + date.getDate()).padStart(2, '0')}`;
}

const ExportWarrantyModal = (props: IProps) => {

  const onClose = () => {
    props.closeModal();
  };

  interface IFormProp {
    warrantyId: string
  }

  const formik = useFormik({
    validationSchema: AppValidationSchema,
    initialValues: {
      warrantyId: "",
      submit: null
    },
    onSubmit: (values, {setSubmitting, setErrors}) => {
      let params = new URLSearchParams();
      params.append("WarrantyId", values.warrantyId);

      apiStore.warrantyApi
        .getWarrantyHistory(params)
        .then((response: IWarrantyHistory[]) => {

          const data = response.map(item => {
            return {
              'warrantyId': item.warrantyId,
              'warrantyType': item.warrantyType,
              'hin': item.hin,
              'expirationDate': item.expirationDate,
              'expirationDate2': item.expirationDate2,
              'effectiveDate': item.effectiveDate,
              'deliveryDate': item.deliveryDate,
              'purchaseDate': item.purchaseDate,
              'boatSeries': item.boatSeries,
              'boatModel': item.boatModel,
              'modelYear': item.modelYear,
              'revision': item.revisionNum,
              'engineMake': item.engineMake,
              'serialNumber': item.serialNumber,
              'customerId': item.customerId,
              'dealerName': item.dealerName,
              'firstName': item.firstName,
              'lastName': item.lastName,
              'phone': item.phone,
              'email': item.email,
              'streetAddress1': item.streetAddress1,
              'streetAddress2': item.streetAddress2,
              'city': item.city,
              'state': item.state,
              'country': item.country,
              'postalCode': item.postalCode,
            }
          });

          const headers = [
            'warrantyId',
            'warrantyType',
            'hin',
            'expirationDate',
            'expirationDate2',
            'effectiveDate',
            'deliveryDate',
            'purchaseDate',
            'boatSeries',
            'boatModel',
            'modelYear',
            'revision',
            'engineMake',
            'serialNumber',
            'customerId',
            'dealerName',
            'firstName',
            'lastName',
            'phone',
            'email',
            'streetAddress1',
            'streetAddress2',
            'city',
            'state',
            'country',
            'postalCode',
          ];

          exportToCSV(`Warranty_${getDateString()}`, data, headers);
          onClose();
        })
    }
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={8} xl={6}>
            <InputLabel>Enter Warranty ID</InputLabel>
            <TextField
                fullWidth
                size="small"
                id="warrantyId"
                {...formik.getFieldProps("warrantyId")}
                
                error={Boolean(formik.touched?.warrantyId && formik.errors?.warrantyId )}
            />
            {formik.touched?.warrantyId && formik.errors.warrantyId && (
            <FormHelperText error id="warrantyId-helper">
                {formik.errors?.warrantyId}
            </FormHelperText>
            )}
            
          </Grid>
          <Grid item xs ={12}>
            <Typography sx={{ fontSize: "11px" }}>
              * Exported data will include all records greater than or equal to warranty id.
            </Typography>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={2}
              sx={{ mt: 2.5 }}
            >
                <Button
                  variant="outlined"
                  disabled={formik.isSubmitting}
                  onClick={ onClose }
                  color="secondary"
                >
                    {" "} Cancel{" "}
                </Button>
                <Button
                    disabled={formik.isSubmitting}
                    type="submit"
                    variant="contained"
                >
                    Export
                </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  )


}


export default ExportWarrantyModal;